var _Lazy_factory, _Lazy_value, _Lazy_waitForValue, _Lazy_valueCreated;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import isUndefined from './TypeHelpers/isUndefined';
/**
 * Lazy wrapper for a factory.
 */
export default class Lazy {
    /**
     * Create a new Lazy object that invokes the factory when
     * `value` is called for the first time.
     *
     * By default, if the factory returns `undefined`, the value of
     * `isValueCreated` will not be true. To alter this set
     * `waitForValue` to false.
     */
    constructor(factory, waitForValue = true) {
        _Lazy_factory.set(this, void 0);
        _Lazy_value.set(this, void 0);
        _Lazy_waitForValue.set(this, void 0);
        _Lazy_valueCreated.set(this, false);
        __classPrivateFieldSet(this, _Lazy_factory, factory, "f");
        __classPrivateFieldSet(this, _Lazy_waitForValue, waitForValue, "f");
    }
    /**
     * Get or create the value.
     */
    get value() {
        if (isUndefined(__classPrivateFieldGet(this, _Lazy_value, "f")) && !__classPrivateFieldGet(this, _Lazy_valueCreated, "f")) {
            __classPrivateFieldSet(this, _Lazy_value, __classPrivateFieldGet(this, _Lazy_factory, "f").call(this), "f");
            if (isUndefined(__classPrivateFieldGet(this, _Lazy_value, "f")) && !__classPrivateFieldGet(this, _Lazy_waitForValue, "f")) {
                __classPrivateFieldSet(this, _Lazy_valueCreated, true, "f");
            }
        }
        return __classPrivateFieldGet(this, _Lazy_value, "f");
    }
    /**
     * Returns `true` if the value has been created.
     */
    get isValueCreated() {
        return __classPrivateFieldGet(this, _Lazy_valueCreated, "f") || __classPrivateFieldGet(this, _Lazy_value, "f") !== undefined;
    }
}
_Lazy_factory = new WeakMap(), _Lazy_value = new WeakMap(), _Lazy_waitForValue = new WeakMap(), _Lazy_valueCreated = new WeakMap();
